export default {"src":"/_next/static/media/envelope-icon.107db138.svg","height":17,"width":22};